"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var Input_1 = __importDefault(require("@material-ui/core/Input"));
var utils_1 = __importDefault(require("@nexys/utils"));
var utils_2 = require("../../utils");
var useStyles = utils_2.makeStyles(function (theme) { return ({
    editor: {
        borderRadius: theme.shape.borderRadius,
        backgroundColor: 'rgba(0,0,0,.1)',
        fontFamily: 'monospace',
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word'
    }
}); });
var Textarea = function (_a) {
    var data = _a.data, name = _a.name, onChange = _a.onChange, className = _a.className, id = _a.id, rows = _a.rows, rowsMax = _a.rowsMax, placeholder = _a.placeholder;
    var classes = useStyles();
    var strName = name.toString();
    var v = utils_1["default"].ds.get(strName, data);
    var value = v !== null ? v : '';
    var handleChange = function (x) {
        return onChange({ name: String(name), value: x.target.value });
    };
    var classNames = [classes.editor];
    if (className) {
        classNames.push(className);
    }
    return (react_1["default"].createElement(Input_1["default"], { id: id ? id : strName, name: strName, value: value, onChange: handleChange, rows: rows, rowsMax: rowsMax, placeholder: placeholder, className: classNames.join(' '), multiline: true }));
};
exports["default"] = Textarea;
